import { ProjectNotesPopoverLocalDraft } from './ProjectNotesPopoverLocalDraft';
import { ProjectNotesPopoverServer } from './ProjectNotesPopoverServer';
import { PersonNotesPopoverServer } from './PersonNotesPopoverServer';
import { isLocalDraftNotesProps, type ProjectNotesPopoverProps } from './ProjectNotesPopover.types';

import './ProjectNotesPopover.css';

export { PersonNotesPopoverServer };
export type {
  NotesPopoverNoteLike,
  PersonNotesPopoverServerProps,
  ProjectNoteDraftItem,
  ProjectNotesLocalDraft,
  ProjectNotesPopoverServerProps,
  ProjectNotesPopoverLocalDraftProps,
  ProjectNotesPopoverProps,
} from './ProjectNotesPopover.types';

export function ProjectNotesPopover(props: ProjectNotesPopoverProps) {
  if (isLocalDraftNotesProps(props)) {
    return (
      <ProjectNotesPopoverLocalDraft
        open={props.open}
        onClose={props.onClose}
        anchorEl={props.anchorEl}
        localDraft={props.localDraft}
      />
    );
  }
  return (
    <ProjectNotesPopoverServer
      open={props.open}
      onClose={props.onClose}
      anchorEl={props.anchorEl}
      project={props.project}
    />
  );
}
